import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { UseFormReturn } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

type IdFieldProps = {
  canUpdate: boolean;
  form: UseFormReturn<AuthProvider>;
};

export const IdField = ({ form, canUpdate }: IdFieldProps) => (
  <FormField
    control={form.control}
    name="id"
    render={({ field }) => (
      <FormItem>
        <FormLabel>ID</FormLabel>
        <FormControl>
          <Input
            {...field}
            disabled={!canUpdate}
            onChange={(e) => {
              const value = e.target.value
                .toLowerCase()
                .replace(/[^a-z0-9_-]/g, "");
              field.onChange(value);
            }}
            placeholder="my-oauth-provider"
          />
        </FormControl>
        <FormMessage />
        <FormDescription>
          Unique identifier limited to lowercase, numbers, underscores, and
          hyphens.
        </FormDescription>
      </FormItem>
    )}
  />
);
